import React from 'react';
import SeoHead, { type SeoHeadProps } from './SeoHead';
import { getPageSeo } from '../content';

export type PageSeoProps = {
  /** Must match an entry in src/content/pages.ts */
  path: string;
} & Partial<Omit<SeoHeadProps, 'path'>>;

/**
 * Route SEO from src/content/pages.ts.
 * Pass overrides only when needed (e.g. blog article timestamps).
 */
function PageSeo({ path, title, description, ...rest }: PageSeoProps) {
  const base = getPageSeo(path);
  return (
    <SeoHead
      {...base}
      {...rest}
      path={base.path}
      title={title ?? base.title}
      description={description ?? base.description}
    />
  );
}

export default PageSeo;
